import { utils, writeFile } from "xlsx";
import type { WorkBook, WritingOptions } from "xlsx";

interface AoAToSheet<T = any> {
  data: T[];
  headerMapper: any;
  filename?: string;
  exclude?: (keyof T)[];
  write2excelOpts?: WritingOptions;
}
const DEF_FILE_NAME = "excel-list.xlsx";

/**
 *
 * @param param0{
 * 　data: テーブルデータ
 *   headerMapper: テーブルheaderのpropとnameのmapper
 * 　filename:出力ファイル名
 *   exclude :出力しない列
 * 　write2excelOpts:出力オプション
 * }
 */
export async function aoaToSheetXlsx<T = any>({
  data,
  headerMapper,
  filename = DEF_FILE_NAME,
  exclude,
  write2excelOpts = { bookType: "xlsx" },
}: AoAToSheet<T>) {
  //出力情報
  let arrHeader;
  let arrData;

  if (exclude) {
    arrHeader = Object.keys(data[0])
      .filter((key) => !exclude.includes(key as keyof T))
      .map((key) => headerMapper[key as keyof T]);
    arrData = data.map((item: T) =>
      Object.keys(item)
        .filter((key) => !exclude.includes(key as keyof T))
        .map((key) => item[key as keyof T])
    );
  } else {
    arrHeader = Object.keys(data[0]).map((key) => headerMapper[key as keyof T]);
    arrData = data.map((item) => Object.values(item));
  }

  arrData.unshift(arrHeader);

  const worksheet = utils.aoa_to_sheet(arrData);

  //ブックにシートを追加
  const workbook: WorkBook = {
    SheetNames: [filename],
    Sheets: {
      [filename]: worksheet,
    },
  };
  //ダウンロード
  writeFile(workbook, filename, write2excelOpts);
}
